import { useDispatch, useSelector } from 'react-redux';
import { datasetSliceName, userDataSliceName } from '@/redux/constants';
import { triggerPreviewModeUpsellModal } from '@/Utils/utils';

export const useShowPreviewModeUpsellModal = () => {
  const { currentFile } = useSelector((state) => state[datasetSliceName]);
  const { user } = useSelector((state) => state[userDataSliceName]);
  const dispatch = useDispatch();

  const showPreviewModal = (title = null) => {
    triggerPreviewModeUpsellModal({ dispatch, currentFile, user, title });
  };

  return showPreviewModal;
};
